import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';
import { plural } from '@cian/utils/lib/shared/plural';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { CardSectionShutter } from 'shared/components/CardSectionShutter';

import { getFilteredRoomsInfo } from './helpers';
import { NewbuildingFeatures } from '../../components/NewbuildingFeatures/NewbuildingFeatures';
import { NewbuildingStats } from '../../components/NewbuildingStats';
import { isNewbuildingSelector, offerSelector } from '../../selectors';
import { selectNewObject } from '../../selectors/newObject/selectNewObject';
import { INewBuildingWithFeatures } from '../../types/newobject/newobject';

function getSubTitle(newObject: INewBuildingWithFeatures): string {
  const { totalCountOfferInNewobject: total, status } = newObject;
  const subtitle: string[] = [];

  if (total) {
    subtitle.push(`${numberToPrettyString(total)} ${plural(total, ['квартира', 'квартиры', 'квартир'])} в продаже`);
  }

  if (status) {
    subtitle.push(status);
  }

  return subtitle.join(' · ');
}

export const NewbuildingStatsContainer = () => {
  const offer = useSelector(offerSelector);
  const newObject = useSelector(selectNewObject);
  const isNewBuilding = useSelector(isNewbuildingSelector);

  if (!newObject?.roomsInfo || !newObject?.roomsInfo.length) {
    return null;
  }

  return (
    <CardSectionShutter hideForPrint title="Ещё квартиры в жилом комплексе">
      <NewbuildingStats
        roomsInfo={getFilteredRoomsInfo(newObject.roomsInfo, offer)}
        subtitle={getSubTitle(newObject as INewBuildingWithFeatures)}
        newbuildingFeatures={
          isNewBuilding && newObject?.newbuildingFeatures ? (
            <NewbuildingFeatures
              newbuildingFeatures={newObject.newbuildingFeatures}
              url={newObject.fullUrlWithSubdomain || newObject.url}
            />
          ) : null
        }
      />
    </CardSectionShutter>
  );
};
